import {PlaceholderWrapper} from '@hconnect/common/components/placeholderWrapper'
import {useTranslation} from 'react-i18next'

import {useTranslationPrefix} from '../hooks/useTranslationPrefix'

export const NotAvailablePage: React.FC = () => {
  const {t} = useTranslation()
  const {performancePrefix} = useTranslationPrefix()

  return (
    <PlaceholderWrapper>
      <span>{t(`${performancePrefix}.unauthorized`)}</span>
    </PlaceholderWrapper>
  )
}
